import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { UserPlus, Wallet, LineChart } from "lucide-react";

const icons = [UserPlus, Wallet, LineChart];

export default function Steps() {
  const steps = useContent().steps;
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center reveal">
          <div className="gold-rule mx-auto mb-6" />
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{steps.title}</h2>
        </div>

        <div className="relative grid md:grid-cols-3 gap-8 mt-16">
          <div className="hidden md:block absolute top-8 left-[16%] right-[16%] h-px bg-[#e7e2d8]" />
          {steps.items.map((s, i) => {
            const Icon = icons[i];
            return (
              <div key={s.no} className="relative text-center">
                <div className="w-16 h-16 rounded-full bg-white border border-[#e7e2d8] flex items-center justify-center mx-auto mb-6 relative z-10">
                  <Icon size={26} className="text-[#b08d57]" />
                </div>
                <div className="eyebrow mb-2">{steps.stepWord} {s.no}</div>
                <h3 className="font-serif-lux text-2xl text-[#16233d] mb-2">{s.title}</h3>
                <p className="text-[#5c6577] text-sm leading-relaxed max-w-xs mx-auto">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
